export const ORDER_SERVICES_TYPES: Record<string, common.OrderServicesType> = {
  Appointment: 'Appointment',
  Delivery: 'Delivery',
  Billing: 'Billing',
};
